import Head from 'next/head'
import React, { } from 'react'
import PolicyContent from '../../components/PolicyContent'
import getConfig from 'next/config'
import dayjs from 'dayjs'

const { publicRuntimeConfig } = getConfig()
interface ContainerProps {
  privacyNotice: any
}

const Privacy: React.FC<ContainerProps> = ({ privacyNotice }) => {
  const lastModified = privacyNotice.modified
  const templateArr = JSON.parse(privacyNotice?.template)
  const headerTitle = templateArr.find(temp => temp.type === 'headertitle')

  return (
    <div id="main-content">
      <Head>
        <title>pOpshelf Privacy Notice for Employees, Applicants & Contractors in CA</title>
        <meta name="description" content="pOpshelf privacy policy..." />
      </Head>
      <div className="privacy-policy" id="privacypolicy">
      <div className="privacy-policy__hero-ribbon">
          <h1>{headerTitle.value}</h1>
        </div>
        <div className="privacy-policy__row">
          <p className="privacy-policy__row-content--bold privacy-policy__date">{`LAST MODIFIED: ${dayjs(new Date(lastModified)).format('MMM DD, YYYY')}`}</p>
        </div>
        <PolicyContent templateData={templateArr}/>
      </div>
    </div>
  )
}

export const getServerSideProps = async () => {
  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/user/${publicRuntimeConfig.ENV}/policypage?popkey=${publicRuntimeConfig.POP_KEY}&slug=ca-privacy-notice-employees-contractor`
  )
  const response = await res.json()
  return {
    props: {
      privacyNotice: response[0]
    }
  }
}

export default Privacy
